import { Close as PopoverClosePrimitive } from '@radix-ui/react-popover';

import { CloseIcon } from '../../icons';

import { PopoverCloseButton } from './styled';

type Props = {
  className?: string;
};

const PopoverClose = ({ className }: Props) => (
  <PopoverClosePrimitive asChild>
    <PopoverCloseButton
      className={className}
      icon={CloseIcon}
      label="Close"
      size="small"
      variant="simple"
    />
  </PopoverClosePrimitive>
);

export default PopoverClose;
